/* ================================
   OMEGA CART ENGINE — FULL ULTRA
   ================================ */
(function () {
  if (window.OmegaCart) return;

  /* -------------------------------
     UTILITY FUNCTIONS
  ------------------------------- */
  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    const amount = cents / 100;
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  function getAllCartBubbles() {
  // Returns all possible bubbles: desktop, mobile, legacy
  return Array.from(document.querySelectorAll(
    '.omega-cart-count, [data-omega-cart-count], .omega-bottom-nav-item .omega-cart-trigger .omega-cart-count'
  ));
}

/* -------------------------------
   SHOPIFY CHECKOUT HELPER
-------------------------------- */
function buildCheckoutURL(cart) {
  if (!cart.items?.length) return '/checkout';

  // Shopify allows /checkout?items[]=variantId:qty
  const params = cart.items.map(i => `items[${i.variant_id}]=${i.quantity}`).join('&');
  return `/checkout?${params}`;
}


  function updateCartCount(cart) {
  const count = cart.item_count || 0;

  requestAnimationFrame(() => {
    const bubbles = getAllCartBubbles();
    if (!bubbles.length) return console.warn('[OmegaCart] No visible bubble found for update!');

    bubbles.forEach(bubble => {
      bubble.textContent = count;

      // Show only if count > 0
      bubble.style.display = count > 0 ? 'flex' : 'none';

      // Pulse animation
      bubble.classList.add('pulse');
      setTimeout(() => bubble.classList.remove('pulse'), 280);
    });
  });
}

function triggerCartDopamine() {
  const triggers = document.querySelectorAll('[data-omega-cart-trigger]');
  triggers.forEach(trigger => {
    trigger.classList.add('cart-dopamine');
    setTimeout(() => {
      trigger.classList.remove('cart-dopamine');
    }, 550);
  });
}


  /* -------------------------------
     OMEGACART STATE
  ------------------------------- */
  window.OmegaCart = {
    state: { items: [], item_count: 0, total_price: 0 },
    subscribers: [],

    subscribe(fn) { if (typeof fn === 'function') this.subscribers.push(fn); },
    notify() { this.subscribers.forEach(fn => fn(this.state)); },

    async fetchCart() {
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
        const cart = await res.json();
        this.state = cart;
        this.notify();
        return cart;
      } catch (e) { console.error('[OmegaCart] fetchCart failed', e); }
    },

    async addItem(formData, optimisticQty = 1) {

setTimeout(() => {
  triggerCartDopamine();
}, 300);

  // Optimistic UI update
  this.state.item_count += optimisticQty;
  updateCartCount(this.state);
  this.notify();

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    });

    if (!res.ok) throw new Error('Add to cart failed');

    await this.fetchCart();

  } catch (e) {
    console.error('[OmegaCart] addItem failed', e);

    // rollback optimistic state
    this.state.item_count -= optimisticQty;
    updateCartCount(this.state);
    this.notify();
  }
},

        async changeItemByKey(key, qty) {
      const item = this.state.items.find(i => i.key === key);
      if (!item) return;

      // ----- OPTIMISTIC UPDATE -----
      item.quantity = qty;
      updateCartCount(this.state); // only bubble count / dopamine
      // No notify for full UI here!

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: qty })
        });

        // ----- CONFIRMED UPDATE -----
        await this.fetchCart(); // full update, triggers full updateCartUI() and notify()
      } catch (e) {
        console.error('[OmegaCart] changeItemByKey failed', e);
        await this.fetchCart(); // rollback to server state
      }
    }

  };

  /* -------------------------------
     CART DRAWER INIT
  ------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.getElementById('omega-cart-drawer');
    if (!drawer) return;

    const emptyState = drawer.querySelector('[data-cart-empty]');
    const productState = drawer.querySelector('[data-cart-has-items]');
    const itemsRow = drawer.querySelector('.omega-cart-items-row');
    const subtotalEl = drawer.querySelector('.omega-cart-total-amount');
    const savingsEl = drawer.querySelector('.omega-cart-savings-amount');

/* ===========================
   DRAWER + SWIPE CONTROL (STABLE)
=========================== */

let startY = 0;
let currentY = 0;
let isDragging = false;
let startTime = 0;
let isClosing = false;

const closeThreshold = 0.48; // 28% drag required
const minVelocity = 0.6;     // fast swipe threshold (px/ms)

/* -------------------------------
   SWIPE / DRAG LOGIC
-------------------------------- */

drawer.addEventListener('touchstart', e => {
  if (isClosing) return;

  // If dragging inside scrollable items and not at top → ignore
  const scrollable = e.target.closest('.omega-cart-items-row');
  if (scrollable && scrollable.scrollTop > 0) return;

  startY = e.touches[0].clientY;
  currentY = startY;
  startTime = performance.now();
  isDragging = true;

  drawer.style.transition = 'none';
});

drawer.addEventListener('touchmove', e => {
  if (!isDragging || isClosing) return;

  currentY = e.touches[0].clientY;
  const diff = currentY - startY;

  if (diff > 0) {
    drawer.style.transform = `translateY(${diff}px)`;
    e.preventDefault(); // prevent background scroll
  }
});

drawer.addEventListener('touchend', () => {
  if (!isDragging || isClosing) return;
  isDragging = false;

  const diff = currentY - startY;
  const duration = performance.now() - startTime;
  const velocity = diff / duration;
  const drawerHeight = drawer.getBoundingClientRect().height;
  const draggedFraction = diff / drawerHeight;

  const shouldClose =
    draggedFraction > closeThreshold || velocity > minVelocity;

  // Always reset transform smoothly
  drawer.style.transition = 'transform 0.25s ease';
  drawer.style.transform = '';

  if (shouldClose) {
    closeDrawer();
  }
  
});

/* -------------------------------
   BLOCK BACKGROUND SCROLL BLEED
-------------------------------- */

drawer.addEventListener('touchmove', e => {
  if (isClosing) return;

  const scrollable = e.target.closest('.omega-cart-items-row');

  // If user is touching empty drawer space (not the scrollable list)
  if (!scrollable) {
    e.preventDefault();
  }

}, { passive: false });


/* -------------------------------
   OMEGA SWEEP EFFECT
-------------------------------- */

function runOmegaSweep() {
  const pills = document.querySelectorAll('.omega-cart-collection-pill');
  pills.forEach(p => p.classList.remove('omega-sweep-highlight'));
  pills.forEach((p, i) =>
    setTimeout(() => {
      p.classList.add('omega-sweep-highlight');
      setTimeout(() => p.classList.remove('omega-sweep-highlight'), 520);
    }, i * 140)
  );
}

// Dynamically set viewport height for all devices
function setOmegaCartHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--omega-cart-vh', `${vh}px`);
}

// Run on load and on resize
setOmegaCartHeight();
window.addEventListener('resize', setOmegaCartHeight);

/* -------------------------------
   OPEN / CLOSE (LOCKED)
-------------------------------- */

function openDrawer() {
  if (isClosing) return;

  const scrollY = window.scrollY;

  drawer.classList.add('active');
  document.body.classList.add('omega-cart-open');

  // HARD FREEZE BODY
  document.body.dataset.scrollY = scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';

  setTimeout(runOmegaSweep, 420);
}

function closeDrawer() {
  if (isClosing) return;
  isClosing = true;

  drawer.classList.remove('active');
  document.body.classList.remove('omega-cart-open');

  const scrollY = document.body.dataset.scrollY || 0;

  // UNFREEZE BODY
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';

  window.scrollTo(0, parseInt(scrollY));

  setTimeout(() => {
    drawer.style.transition = '';
    drawer.style.transform = '';
    isClosing = false;
  }, 300);
}

window.OmegaCart.open = openDrawer;
window.OmegaCart.close = closeDrawer;


    /* -------------------------------
   CART TRIGGER HANDLING
------------------------------- */
document.addEventListener('click', e => {
  const trigger = e.target.closest('[data-omega-cart-trigger]');
  if (!trigger) return;
  e.preventDefault();
  if (window.OmegaCart?.open) window.OmegaCart.open();
});


    drawer.querySelectorAll('.omega-cart-close').forEach(btn => btn.addEventListener('click', closeDrawer));
    drawer.querySelector('.omega-cart-backdrop')?.addEventListener('click', closeDrawer);

    function updateCartUI(cart) {
      const hasItems = cart.items?.length > 0;
      drawer.classList.toggle('omega-has-items', hasItems);
      emptyState.style.display = hasItems ? 'none' : 'flex';
      productState.style.display = hasItems ? 'flex' : 'none';
      itemsRow.innerHTML = '';

      if (hasItems) {
        cart.items.forEach(item => {
          const row = document.createElement('div');
          row.className = 'omega-cart-item-row';
          row.dataset.key = item.key;

          const productTitle = item.product_title || '';
          const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          const fullTitle = variantTitle ? `${productTitle} – ${variantTitle}` : productTitle;
          const imageSrc = item.image || '';
          const price = item.price;
          const comparePrice = item.original_price && item.original_price > item.price ? item.original_price : null;

          row.innerHTML = `
            <div class="omega-cart-item-image">${imageSrc ? `<img src="${imageSrc}" alt="${fullTitle}">` : ''}</div>
            <div class="omega-cart-item-info">
              <div class="omega-cart-item-title">${fullTitle}</div>
              <div class="omega-cart-item-price-stack">
                ${comparePrice ? `<span class="omega-cart-compare-price">${formatMoney(comparePrice)}</span>` : ''}
                <span class="omega-cart-final-price">${formatMoney(price)}</span>
              </div>
            </div>
            <div class="omega-cart-item-controls">
              <div class="quantity-wrapper">
                <button class="qty-minus">−</button>
                <input class="omega-cart-quantity" value="${item.quantity}" readonly />
                <button class="qty-plus">+</button>
              </div>
              <button class="omega-cart-remove">×</button>
            </div>
          `;
          itemsRow.appendChild(row);

          const input = row.querySelector('.omega-cart-quantity');
          row.querySelector('.qty-plus').onclick = () => window.OmegaCart.changeItemByKey(item.key, parseInt(input.value, 10) + 1);
          row.querySelector('.qty-minus').onclick = () => {
            let qty = parseInt(input.value, 10) - 1; 
            if (qty < 1) qty = 1;
            window.OmegaCart.changeItemByKey(item.key, qty);
          };
          row.querySelector('.omega-cart-remove').onclick = () => window.OmegaCart.changeItemByKey(item.key, 0);
        });
      }

      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price ?? cart.total_price);

      let totalSavings = 0;
      cart.items?.forEach(item => { 
        const c = Number(item.properties?._compare_at_price); 
        if (c && c > item.price) totalSavings += (c - item.price) * item.quantity; 
      });
      if (savingsEl) savingsEl.textContent = formatMoney(totalSavings);

      // CTA priming
      const cta = document.querySelector('.omega-primary-cta');
      if (cta && hasItems) { 
        cta.classList.add('is-primed'); 
        setTimeout(() => cta.classList.remove('is-primed'), 480); 
      }
    }

    window.OmegaCart.subscribe(updateCartUI);
    window.OmegaCart.subscribe(updateCartCount);

    window.OmegaCart.fetchCart();
  });

  /* ------------
     PRIMARY CTA 
  --------------- */
document.addEventListener('click', e => {
  const btn = e.target.closest('.omega-primary-cta');
  if (!btn) return;

  e.preventDefault(); // we control redirect
  const span = btn.querySelector('span');

  // Immediate visual feedback
  btn.classList.add('omega-loading');
  btn.setAttribute('aria-busy', 'true');
  if (span) span.textContent = 'Securing your items…';

  // Fetch latest cart for accurate variants & quantities
  window.OmegaCart.fetchCart().then(cart => {
    const checkoutURL = buildCheckoutURL(cart);
    window.location.href = checkoutURL; // redirect to Shopify checkout
  }).catch(err => {
    console.error('[OmegaCart] Failed to fetch cart for checkout', err);
    btn.classList.remove('omega-loading');
    btn.removeAttribute('aria-busy');
    if (span) span.textContent = 'Complete my order';
  });
});


  window.addEventListener('pageshow', () => {
    const btn = document.querySelector('.omega-primary-cta'); 
    if (!btn) return; 
    btn.classList.remove('omega-loading'); 
    btn.removeAttribute('disabled'); 
    btn.innerHTML = `<span>Complete my order</span>`;
  });

  document.addEventListener('omega:cart:open', () => {
    const btn = document.querySelector('.omega-primary-cta'); 
    if (!btn) return; 
    btn.classList.add('omega-cta-primed'); 
    setTimeout(() => btn.classList.remove('omega-cta-primed'), 900);
  });
})();
